// DS: i4.31
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorLink: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M16.95 14.121l1.414-1.414a5 5 0 00-7.07-7.07L9.878 7.05l-.078.088a1 1 0 00.078 1.327l.087.077a1 1 0 001.327-.077l1.414-1.415.129-.12a3 3 0 014.114 4.363l-1.414 1.414-.078.087a1 1 0 001.492 1.327zm-2.121-4.95a1 1 0 010 1.415l-4.243 4.242a1 1 0 01-1.414-1.414l4.242-4.242a1 1 0 011.415 0zm-.707 6.365a1 1 0 01.077 1.327l-.077.087-1.415 1.414a5 5 0 01-7.07-7.071L7.05 9.879l.087-.078a1 1 0 011.404 1.405l-.077.086-1.414 1.415a3 3 0 004.114 4.364l.128-.121 1.415-1.415.087-.077a1 1 0 011.327.078z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorLink.displayName = 'EditorLink';

export default EditorLink;
